// Настройки графиков
export const reportChartSettings = {
    data() {
        return {
            optionsChartBars: {
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        fontColor: "#000000",
                        boxWidth: 50,
                        fontStyle: "bold",
                        padding: 15,
                        fontSize: 15,
                    },
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: true,
                    }, ],
                    yAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: true,
                    }, ],
                },
                plugins: {
                    datalabels: {
                        // display: true,  //auto
                        display: function(context) {
                            return context.dataset.data[context.dataIndex] >= 2; // display labels with an odd index
                        },
                        align: 'center',
                        anchor: 'center',
                        color: "#362518",
                        font: {
                            // weight: "bold",
                            size: 8
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            },
            optionsChartLine: {
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        fontColor: "#000000",
                        boxWidth: 15,
                        fontStyle: "normal",
                        padding: 15,
                        fontSize: 14,
                    },
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: false,
                    }, ],
                    yAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: false,
                    }, ],
                },
                tooltips: {
                    mode: 'index',
                    position: 'average',
                    intersect: false,
                },
                responsive: true,
                maintainAspectRatio: false,
            },
            optionsChartLineMoney: {
                animation: {
                  duration: 300
                },
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        fontColor: "#000000",
                        boxWidth: 15,
                        fontStyle: "normal",
                        padding: 15,
                        fontSize: 14
                    },
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: false,
                    }, ],
                    yAxes: [{
                        ticks: {
                            fontStyle: "bold",
                            callback: function(value, index, values) {
                                if (typeof value !== "number") {
                                    return value
                                }
                                let formatter = new Intl.NumberFormat('ru-RU', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                })
                                return formatter.format(value) + ' р.'
                            }
                        },
                        stacked: false,
                    }, ],
                },
                tooltips: {
                    mode: 'index',
                    position: 'average',
                    intersect: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            let formatter = new Intl.NumberFormat('ru-RU', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                            return formatter.format(tooltipValue) + ' р.'
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },
            optionsTopChartLine: {
                legend: {
                    display: false,
                },
                legendCallback: function(chart) {
                    let topLegendButtons = []
                    let items = chart.data.datasets

                    topLegendButtons.push({
                        label: 'Все',
                        active: true,
                        color: '#000'
                    })

                    items.forEach((item) => {
                        topLegendButtons.push({
                            label: item.label,
                            active: true,
                            color: item.borderColor
                        })
                    })

                    return topLegendButtons
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: false,
                    }, ],
                    yAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: false,
                    }, ],
                },
                tooltips: {
                    mode: 'index',
                    position: 'average',
                    intersect: false,
                },
                responsive: true,
                maintainAspectRatio: false,
            },
            optionsTopChartLineMoney: {
                legend: {
                    display: false,
                },
                legendCallback: function(chart) {
                    let topLegendButtons = []
                    let items = chart.data.datasets

                    topLegendButtons.push({
                        label: 'Все',
                        active: true,
                        color: '#000'
                    })

                    items.forEach((item) => {
                        topLegendButtons.push({
                            label: item.label,
                            active: true,
                            color: item.borderColor
                        })
                    })

                    return topLegendButtons
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontStyle: "bold",
                        },
                        stacked: false,
                    }, ],
                    yAxes: [{
                        ticks: {
                            fontStyle: "bold",
                            callback: function(value, index, values) {
                                if (typeof value !== "number") {
                                    return value
                                }
                                let formatter = new Intl.NumberFormat('ru-RU', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                })
                                return formatter.format(value) + ' р.'
                            }
                        },
                        stacked: false,
                    }, ],
                },
                tooltips: {
                    mode: 'index',
                    position: 'average',
                    intersect: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            let formatter = new Intl.NumberFormat('ru-RU', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                            return formatter.format(tooltipValue) + ' р.'
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        }
    },
    watch: {
        "$mq": {
            handler(value) {
                if (value == 'xl') {
                    this.optionsChartBars.plugins.datalabels.font.size = 14
                } else {
                    this.optionsChartBars.plugins.datalabels.font.size = 10
                }
            },
            immediate: true
        },
    },
    // methods: {
    // }
}
